export const productTypes = [
  { type: 'Pants', code: '6204.69.90.00.00' },
  { type: 'Shirt', code: '6206.90.90.00.12' },
  { type: 'Skirt', code: '6204.59.90.00.00' },
  { type: 'Underwear', code: '6208.99.00.00.00' },
  { type: 'Accessorize', code: '6217.10.00.00.19' },
  { type: 'Bag', code: '4202.32.90.90.00' },
  { type: 'Jackets', code: '6204.39.90.00.00' },
  { type: 'Shoes', code: '6403.99.98.00.00' },
  { type: 'Toys', code: '9503.00.99.00.00' },
  { type: 'Home Appliances', code: '8509.40.00.00.19' },
  { type: 'Electronic Devices', code: '8471.90.00.00.00' },
  { type: 'Home Textile', code: '6302.21.00.00.19' },
  { type: 'Jewellery', code: '7117.19.00.90.29' },
  { type: 'Chips & Doritos', code: '2005.19.00.90.29' },
  { type: 'Waffles & Biscuits', code: '1905.19.00.90.29' },
  { type: 'Coffee Capsules', code: '0901.19.00.90.29' },
  { type: 'Perfumes', code: '3303.19.00.90.29' },
  { type: 'Personal Care', code: '3307.19.00.90.29' },
  { type: 'Contact Lenses', code: '3307.19.00.90.29' },
  { type: 'Beauty Creams and Makeup', code: '3304.19.00.90.29' },
].sort(function (a, b) {
  if (a.type < b.type) {
    return -1
  }
  if (a.type > b.type) {
    return 1
  }
  return 0
})

export const getCodeByType = type => {
  const retr = productTypes.find(pt => pt.type === type)
  return retr?.code || ''
}
